import { atom } from "recoil";
import { v4 as uuidv4 } from "uuid";

export const initItem = () => {
  const id = uuidv4();
  return {
    id,
    key: id,
    q: { content: [], required: true, type: "text" },
    option: { content: "" },
    answers: [],
  };
};
export const surveyInfoTitle = atom({
  key: "survey/info/title",
  default: "",
});

export const surveyInfoContents = atom({
  key: "survey/info/contents",
  default: [],
});

export const surveyList = atom({
  key: "survey/info/list",
  default: [{ ...initItem() }],
});
export const surveyResponseList = atom({
  key: "survey/response/list",
  default: [],
});

export const surveyResponseTime = atom({
  key: "survey/response/time",
  default: 0,
});

export const surveyFocusIndex = atom({
  key: "survey/info/index",
  default: 0,
});
